import { color } from '@coursera/coursera-ui';

import type { DiscoveryCollectionEntity } from 'bundles/browse/components/types/DiscoveryCollections';
import type {
  PreformattedDataFromBrowseForSavedDataLookup,
  ProductForSavedDataLookup,
} from 'bundles/browse/types/withSavedDataFromProducts';

import _t from 'i18n!nls/browse';

const savingSupportedProducts = {
  SPECIALIZATION: 's12n',
  CERTIFICATE: 'professional_certificate',
  DEGREE: 'degree',
  MASTERTRACK: 'mastertrack',
  GUIDED_PROJECT: 'project',
  COURSE: 'course',
  SEARCH_CARD: 'search_card',
} as const;

type SavingSupportedProduct = (typeof savingSupportedProducts)[keyof typeof savingSupportedProducts];

const productCardsWithWhiteBackground: SavingSupportedProduct[] = [savingSupportedProducts.COURSE];

export const SAVING_BOOKMARK_WHITE = color.white;
export const SAVING_BOOKMARK_PRIMARY = color.primary;
export const SAVING_BOOKMARK_BLACK = color.black;

export const getProductCardTextColor = (type: SavingSupportedProduct) => {
  if (productCardsWithWhiteBackground.includes(type)) return SAVING_BOOKMARK_PRIMARY;

  return SAVING_BOOKMARK_WHITE;
};

export const translateBrowseCarouselContentForSaveLookup = ({
  id,
  isRhymeProject,
  productVariant,
}: PreformattedDataFromBrowseForSavedDataLookup): ProductForSavedDataLookup => {
  let offeringType: SavingSupportedProduct = savingSupportedProducts.COURSE;
  if (isRhymeProject) offeringType = savingSupportedProducts.GUIDED_PROJECT;
  if (productVariant === 'ProfessionalCertificateS12n') offeringType = savingSupportedProducts.CERTIFICATE;
  if (productVariant === 'NormalS12n') offeringType = savingSupportedProducts.SPECIALIZATION;

  return {
    id,
    offeringType,
  };
};

export const translateDiscoveryCollectionCarouselContentForSaveLookup = (
  entity: DiscoveryCollectionEntity | null
): ProductForSavedDataLookup | null => {
  if (!entity) return null;

  let offeringType: SavingSupportedProduct = savingSupportedProducts.COURSE;

  if (entity?.__typename === 'DiscoveryCollections_professionalCertificate') {
    offeringType = savingSupportedProducts.CERTIFICATE;
  } else if (entity?.__typename === 'DiscoveryCollections_guidedProject') {
    offeringType = savingSupportedProducts.GUIDED_PROJECT;
  } else if (entity?.__typename === 'DiscoveryCollections_specialization') {
    offeringType = savingSupportedProducts.SPECIALIZATION;
  }

  return {
    id: entity.id,
    offeringType,
  };
};

export const getBookmarkText = {
  unsaved: () => _t('Save'),
  saved: () => _t('Saved'),
};

export const getTooltipText = {
  unsaved: () => _t('Removed from your '),
  saved: () => _t('Added to your '),
};

export const getAriaText = {
  unsaved: () => _t('Removed from your Saved List'),
  saved: () => _t('Added to your Saved List'),
};
